import React, { Component, PropTypes } from 'react';
import rebase from '../rebase';

import AddItem from './AddItem';
import List from './List';
import Modal from './Modal';

class ListContainer extends Component {
  static propTypes = {
    root: PropTypes.string.isRequired,
    isEditing: PropTypes.bool.isRequired,
    hideSelected: PropTypes.bool.isRequired,
    filter: PropTypes.string.isRequired,
    onSelect: PropTypes.func,
    confirmRemove: PropTypes.bool
  }

  static defaultProps = {
    hideSelected: false,
    filter: ''
  }

  constructor() {
    super();

    this.state = {
      items: [],
      loading: true,
      itemToDelete: null
    }
  }

  componentDidMount() {
    const options = {
       context: this,
       state: 'items',
       asArray: true,
       queries: {
         orderByChild: 'sequence'
       },
       then(data) {
         this.setState({ loading: false });
       }
    };

    this.itemsRef = rebase.bindToState(this.props.root, options);
  }

  componentWillUnmount() {
    rebase.removeBinding(this.itemsRef);
  }

  handleAdd = name => {
    const { items } = this.state;

    const sequence = items.length ? items[items.length - 1].sequence + 2**8 : 2**16;
    const data = { name, sequence, selected: false };

    rebase.push(this.props.root, { data });
  }

  handleInsert = item => {
    const { items } = this.state;

    const itemIndex = items.indexOf(item);
    const prevSequence = itemIndex === 0 ? 0 : items[itemIndex - 1].sequence;

    const sequence = (item.sequence + prevSequence) / 2;
    const data = { name: '', sequence, selected: false };

    rebase.push(this.props.root, { data });
  }

  handleRemove = item => {
    if (this.props.confirmRemove) {
      this.setState({ itemToDelete: item });
    } else {
      rebase.update(this.props.root, { data: { [item.key]: null } });
    }
  }

  handleModalAction = (result, item) => {
    if (result) {
      rebase.update(this.props.root, { data: { [item.key]: null } });
    }

    this.setState({ itemToDelete: null });
  }

  handleSelect = item => {
    if (this.props.onSelect) {
      this.props.onSelect(item.key);
    } else {
      const data = { selected: !item.selected };

      rebase.update(`${this.props.root}/${item.key}`, { data });
    }
  }

  handleEdit = (item, name) => {
    const data = { name };

    rebase.update(`${this.props.root}/${item.key}`, { data });
  }

  handleSortEnd = ({ oldIndex, newIndex }) => {
    if (oldIndex === newIndex) {
      return;
    }

    const { items } = this.state;

    const key = items[oldIndex].key;
    const data = { sequence: this.getNewSequence(items, oldIndex, newIndex) };

    rebase.update(`${this.props.root}/${key}`, { data });
  }

  getNewSequence = (items, oldIndex, newIndex) => {
    const draggingDown = newIndex > oldIndex;
    const isFirstItem = newIndex === 0;
    const isLastItem = newIndex === items.length - 1;

    const targetSequence = items[newIndex].sequence;
    let adjacentSequence;

    if (draggingDown) {
      adjacentSequence = isLastItem ? targetSequence + 2**8 : items[newIndex + 1].sequence;
    } else {
      adjacentSequence = isFirstItem ? 0 : items[newIndex - 1].sequence;
    }

    return (targetSequence + adjacentSequence) / 2;
  }

  // applyFilters = (items, filter, hideSelected) => {
  //   let result = items;
  //
  //   if (filter) {
  //     const filterLC = filter.toLowerCase();
  //     result = result.filter(item => item.name.toLowerCase().includes(filterLC));
  //   }
  //
  //   if (hideSelected) {
  //     result = result.filter(item => !item.selected);
  //   }
  //
  //   return result;
  // }

  render() {
    if (this.state.loading) {
      return <h3>Loading...</h3>;
    }

    if (this.state.items.length === 0) {
      return <AddItem addItem={this.handleAdd} />;
    }

    const { filter, hideSelected } = this.props;

    const filters = [
      filter && textFilter(filter.toLowerCase()),
      hideSelected && selectedFilter
    ];

    const items = filters.reduce(applyFilter, this.state.items);

    // const items = this.applyFilters(this.state.items, this.props.filter, this.props.hideSelected);

    const remainingCount = this.state.items.filter(item => !item.selected).length;

    return (
      <div style={{ height: '100%' }}>
        <List
          items={items}
          isEditing={this.props.isEditing}
          hideSelected={this.props.hideSelected}
          onInsert={this.handleInsert}
          onRemove={this.handleRemove}
          onSelect={this.handleSelect}
          onEdit={this.handleEdit}
          useDragHandle={true}
          helperClass="Item-dragitem"
          onSortEnd={this.handleSortEnd}
          />
        <div className="List-footer">
          <span className="List-footer-count">{`${remainingCount} / ${this.state.items.length}`}</span>
        </div>
        <Modal item={this.state.itemToDelete} onAction={this.handleModalAction} />
      </div>
    );
  }
}

function selectedFilter(items) {
  return items.filter(item => !item.selected)
}

function textFilter(filter) {
  return items => items.filter(item => item.name.toLowerCase().includes(filter))
}

function applyFilter(items, filter) {
  return filter ? filter(items) : items
}

export default ListContainer;



/** WEBPACK FOOTER **
 ** ./src/components/ListContainer.js
 **/